/** 应付账单可手动确认的状态（与后端 confirmPayable、委托单账单 Tab 一致） */
const PAYABLE_CONFIRMABLE_STATUSES = ['DRAFT', 'PENDING'] as const

/**
 * 判断应付账单是否允许执行「确认账单」。
 *
 * @param status 账单状态前端码，如 DRAFT / PENDING / CONFIRMED
 */
export function canConfirmPayableBill(status: string | null | undefined): boolean {
  if (!status) return false
  return (PAYABLE_CONFIRMABLE_STATUSES as readonly string[]).includes(status)
}
